(() => {
  const setView = view => {
    document.documentElement.dataset.archiveView = view;
    document.querySelectorAll('[data-os-view]').forEach(button => {
      const active = button.dataset.osView === view;
      button.classList.toggle('is-selected', active);
      button.setAttribute('aria-pressed', String(active));
    });
    try { sessionStorage.setItem('midtown-view', view); } catch (error) {}
  };
  try { setView(sessionStorage.getItem('midtown-view') || 'grid'); } catch (error) { setView('grid'); }
  document.addEventListener('click', event => {
    const view = event.target.closest('[data-os-view]');
    if (view) {
      setView(view.dataset.osView);
      view.closest('details')?.removeAttribute('open');
    }
    if (event.target.closest('[data-os-back]')) history.back();
    if (event.target.closest('[data-os-forward]')) history.forward();
  });
})();
(() => {
  function installRecentCards() {
    if (!window.theme || !theme.buildProductGridItem || theme.buildProductGridItem.midtownUnified) return;
    const original = theme.buildProductGridItem;
    function unifiedCards(...args) {
      const holder = document.createElement('div');
      holder.innerHTML = original.apply(this, args);
      holder.querySelectorAll('.grid-product__meta').forEach(meta => {
        const vendor = meta.querySelector('.grid-product__vendor')?.textContent.trim() || '';
        const title = meta.querySelector('.grid-product__title')?.textContent.trim() || '';
        const price = (meta.querySelector('.grid-product__price')?.textContent.trim() || '').replace(/\.00$/, '');
        const size = meta.querySelector('.grid-product__size')?.textContent.trim() || '';
        const top = document.createElement('div');
        top.className = 'os-product-top';
        const bottom = document.createElement('div');
        bottom.className = 'os-product-bottom';
        [vendor, price].forEach(text => { const span = document.createElement('span'); span.textContent = text; top.appendChild(span); });
        const name = document.createElement('span'); name.textContent = title; bottom.appendChild(name);
        if (size) { const label = document.createElement('small'); label.textContent = size; bottom.appendChild(label); }
        meta.classList.add('os-card-meta');
        meta.replaceChildren(top, bottom);
      });
      return holder.innerHTML;
    }
    unifiedCards.midtownUnified = true;
    theme.buildProductGridItem = unifiedCards;
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', installRecentCards);
  else installRecentCards();
  document.addEventListener('page:loaded', installRecentCards);
})();

(() => {
  let opener;
  document.addEventListener('click', event => {
    const dialog = document.querySelector('.os-spotlight');
    if (!dialog) return;
    const trigger = event.target.closest('[data-os-search]');
    if (trigger) { event.preventDefault(); opener = trigger; dialog.showModal(); dialog.querySelector('input[name="q"]').focus(); }
    if (event.target.closest('[data-os-search-close]') || event.target === dialog) { dialog.close(); opener?.focus(); }
  });
})();

(() => {
  const root = document.documentElement;
  const sync = () => {
    const dark = root.dataset.appearance === 'dark';
    document.querySelectorAll('[data-os-appearance]').forEach(button => {
      button.setAttribute('aria-pressed', String(dark));
      button.setAttribute('aria-label', dark ? button.dataset.lightLabel : button.dataset.darkLabel);
    });
    document.querySelector('meta[name="theme-color"]')?.setAttribute('content', dark ? '#1c1c1e' : '#f2f2f7');
  };
  document.addEventListener('click', event => {
    if (!event.target.closest('[data-os-appearance]')) return;
    root.dataset.appearance = root.dataset.appearance === 'dark' ? 'light' : 'dark';
    try { localStorage.setItem('midtown-appearance', root.dataset.appearance); sessionStorage.setItem('midtown-appearance', root.dataset.appearance); } catch (error) {}
    document.cookie = 'midtown_appearance=' + root.dataset.appearance + '; Max-Age=31536000; Path=/; SameSite=Lax; Secure';
    sync();
  });
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', sync); else sync();
})();
